import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, BillItemsByChargeEntryCodeController, BillItemsByChargeEntryCodeRequest, X_BillItemsController, x_BillDetailsRequest, BillDetailsInfoController, X_BillReceiptsController, X_BillHeaderController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, BillAdvancesListController, BillAdvancesListRequest, AdmissionsByCodeController, AdmissionsByCodeRequest, AdmissionDetailsInfoController } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'admadvancebillindi',
  templateUrl: './admadvancebillindi.component.html',
  styleUrls: ['./admadvancebillindi.component.scss']
})

export class AdmadvancebillindiComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  public logo: string = "";
  public HeaderLine1: string = "";
  public HeaderLine2: string = "";
  //public GST: string;
  //public DL: string;
  public Date: Date;
  public PatientId: any;
  public PatientCode: any;
  public Branchname: any;
  public FormattedCode: any;
  public Branch: string;
  public AdDate: any;
  public AdDated: Date;
  public TotalAdvance: number;
  public Mode: any;
  public AdAmount: any;
  public AdmissionCode: any;

  CurrentBillAdvancesListController: BillAdvancesListController[];

  CurrentBillAdvancesListRequest: BillAdvancesListRequest;



  LoadAdvances() {
    this.CurrentBillAdvancesListRequest = new BillAdvancesListRequest();
    this.CurrentBillAdvancesListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
    this.CurrentBillAdvancesListRequest.PatientCode = this.PatientCode;
    this.CurrentBillAdvancesListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentBillAdvancesListRequest.ConditionalOperator = 10;
    this.GetBillAdvancesListController();
  }
  GetBillAdvancesListController() {
    this.StartRefreshing();


    this.actorservice.GetBillAdvancesListController(this.CurrentBillAdvancesListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillAdvancesListController = this.ApiResData.Result;
          this.TotalAdvance = this.CurrentBillAdvancesListController.filter(l => l.AdvanceAmount)
            .reduce((sum, current) => sum + current.AdvanceAmount, 0);
          //this.ChargeEntryCode = this.CurrentBillDetailsInfoController[0].ChargeEntry;

          //this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadBills();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentAdmissionsByCodeController: AdmissionsByCodeController[];
  CurrentAdmissionsByCodeRequest: AdmissionsByCodeRequest;
  AdmissionData: AdmissionDetailsInfoController;
  SelectedAdmission: AdmissionsByCodeController;
  LoadAdmissionsDetails() {
    this.CurrentAdmissionsByCodeRequest = new AdmissionsByCodeRequest();
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCode');
    this.CurrentAdmissionsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetAdmissionsByCodeController();
  }

  GetAdmissionsByCodeController() {
    this.StartRefreshing();
    this.CurrentAdmissionsByCodeRequest.ConditionalOperator = 10;
    //this.CurrentAdmissionsListRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsByCodeRequest.AdmissionCode = this.AdmissionCode;
    this.CurrentAdmissionsByCodeRequest.FacilityCode = AppData.Instance().SelectedFacilityCode;

    this.actorservice.GetAdmissionsByCodeController(this.CurrentAdmissionsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.AdmissionData = this.ApiResData.Result;
          this.CurrentAdmissionsByCodeController = this.AdmissionData.AdmissionItems;
          this.SelectedAdmission = this.AdmissionData.AdmissionItems[0];
          //this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadBills();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentBillItemsByChargeEntryCodeController: BillItemsByChargeEntryCodeController[];
  CurrentBillItemsByChargeEntryCodeRequest: BillItemsByChargeEntryCodeRequest;



  LoadBills() {
    this.CurrentBillItemsByChargeEntryCodeRequest = new BillItemsByChargeEntryCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentBillItemsByChargeEntryCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBillItemsByChargeEntryCodeRequest.ChargeEntryCode = 10074;
    this.CurrentBillItemsByChargeEntryCodeRequest.ConditionalOperator = 10;
    this.GetBillItemsByChargeEntryCodeController();
  }
  GetBillItemsByChargeEntryCodeController() {
    this.StartRefreshing();


    this.actorservice.GetBillItemsByChargeEntryCodeController(this.CurrentBillItemsByChargeEntryCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillItemsByChargeEntryCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady()
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    this.logo = AppData.Instance().cas.Hlogo;
    this.HeaderLine1 = AppData.Instance().cas.ClientHeaderLine1;
    this.HeaderLine2 = AppData.Instance().cas.ClientHeaderLine2;
    this.Date = new Date();
    this.LoadPatients();
    this.LoadAdvances();
    this.LoadAdmissionsDetails();
    this.Branchname = AppData.Instance().SelectedBranchName;
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
    this.AdDate = this.route.snapshot.paramMap.get('Date');
    this.AdDated = new Date(this.AdDate);
    this.Mode = this.route.snapshot.paramMap.get('Mode');
    this.AdAmount = this.route.snapshot.paramMap.get('AdAmount');
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCode');
    this.Loadadvancerow();
  }
  CurrentAdvanceData: Array<AdvanceData>;

  Loadadvancerow() {
    if (this.CurrentAdvanceData == null) {
      this.CurrentAdvanceData = new Array<AdvanceData>();
    }
    if (this.CurrentAdvanceData != null) {
      var row = new AdvanceData();
      row.BillDate = this.AdDated;
      row.Paymentmode = this.Mode;
      row.AdvanceAmount = this.AdAmount;
      this.CurrentAdvanceData.push(row);
    }
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}

export class AdvanceData {
  public BillDate: Date;
  public Paymentmode: string;
  public AdvanceAmount: string;
}






